<template>
  <div class="main-layout">
    <navbar/>

    <div class="main">
      <child/>
    </div>
  </div>
</template>

<script>
import Navbar from '~/components/Navbar'

export default {
  name: 'MainLayout',

  components: {
    Navbar,
  },
}
</script>
<style scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.main{
  overflow-y: auto;
  background-color: #F6F6F6;
  flex: 1;
}
</style>
